module.exports = __webpack_public_path__ + "img/mill-sign.1a30c228.svg";